import styled, { createGlobalStyle } from "styled-components";

export const LarguraModal = createGlobalStyle`
  .modal-autorizacao-manual {
    max-width: 600px;
  }
`;

export const TextoSecao = styled.p`
  color: ${({ theme }) => theme.colors.neutral.neutral70};
  margin-bottom: 0.75rem;
`;

export const ContainerBotoes = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 16px;
`;
